import React from 'react';
import { Helmet } from 'react-helmet';

export default function ForgetPass() {


  return (
    <>
      <Helmet>
        <title>Forget Password</title>
      </Helmet>
      <>

        <section className="authBody">


          <h1>Forget Password</h1>
          
        </section>
      </>
    </>
  );
}
